<template>
	<div class="circle" :style="{ transform: `scale(${scale})` }"></div>
</template>

<script>
export default {
	props: ["id", "isLocal"],
	data() {
		return {
			maxScale: 3,
			audioContext: null,
			analyser: null,
			microphone: null,
			dataArray: null,
			animationFrameId: null,
			scale: 1,
		};
	},
	mounted() {
		this.setupAudioProcessing();
	},
	methods: {
		setupAudioProcessing() {
			let video = document.getElementById(
				this.isLocal ? "localVideo" : this.id
			);
			if (!video) return;
			let stream = video.srcObject;

			if (!stream) {
				setTimeout(this.setupAudioProcessing, 100);
				return;
			}

			this.audioContext = new (window.AudioContext ||
				window.webkitAudioContext)();
			this.analyser = this.audioContext.createAnalyser();
			this.microphone = this.audioContext.createMediaStreamSource(stream);
			this.microphone.connect(this.analyser);
			this.analyser.fftSize = 256;
			const bufferLength = this.analyser.frequencyBinCount;
			this.dataArray = new Uint8Array(bufferLength);
			this.processAudio();
		},
		processAudio() {
			this.analyser.getByteTimeDomainData(this.dataArray);
			let sum = 0;
			for (let i = 0; i < this.dataArray.length; i++) {
				let value = this.dataArray[i] / 128.0 - 1.0;
				sum += value * value;
			}
			const average = Math.sqrt(sum / this.dataArray.length);
			const newScale = 1 + average * this.maxScale;
			this.scale = newScale;
			this.animationFrameId = requestAnimationFrame(this.processAudio);
		},
	},
	beforeDestroy() {
		cancelAnimationFrame(this.animationFrameId);
		this.audioContext && this.audioContext.close();
	},
};
</script>

<style scoped>
.circle {
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-color: #20649b6d;
	transition: transform 0.1s;
}
</style>

